<template>
    <!-- Content -->
    <!-- 2026.07.17 : REQSDF-9432 - [pcmall] LG Movies & TV Terms & Conditions (US) -->
    <section id="content" class="content terms-cont">
        <div class="content-body">
            <div class="tab-type4-wrap in-sec">
                <nav class="tab-nav tab-change tab-type4 m-aco">
                    <h2 class="terms-tit" v-html="$t('sdp.menu.tvod.head')"></h2>
                    <ul role="tablist">
                        <li role="presentation" class="is-active">
                            <a href="#tabContentTvod1" role="tab" id="tabNavTvod1" aria-controls="tabContentTvod1" aria-selected="true">
                                <span class="tit">{{ $t('sdp.menu.tvod.title.001') }}</span>
                            </a>
                        </li>
                        <li role="presentation">
                            <a href="#tabContentTvod2" role="tab" id="tabNavTvod2" aria-controls="tabContentTvod2" aria-selected="false">
                                <span class="tit">{{ $t('sdp.menu.tvod.title.002') }}</span>
                            </a>
                        </li>
                        <li role="presentation">
                            <a href="#tabContentTvod3" role="tab" id="tabNavTvod3" aria-controls="tabContentTvod3" aria-selected="false">
                                <span class="tit">{{ $t('sdp.menu.tvod.title.003') }}</span>
                            </a>
                        </li>
                    </ul>
                </nav>

                <div class="tab-body">
                    <!-- Tab1_Terms of Use -->
                    <div id="tabContentTvod1" class="tab-content is-active" aria-labelledby="tabNavTvod1">
                        <div id="tvodTermsSec1" class="terms-sec-wrap">
                            <TvodTermsOfUse />
                        </div>
                    </div>
                    <!-- //Tab1_Terms of Use -->

                    <!-- Tab2_Privacy Policy -->
                    <div id="tabContentTvod2" class="tab-content" aria-labelledby="tabNavTvod2">
                        <div id="tvodTermsSec2" class="terms-sec-wrap">
                            <TvodPrivacyPolicy />
                        </div>
                    </div>
                    <!-- //Tab2_Privacy Policy -->

                    <!-- Tab3_Targeted Advertising Opt-In -->
                    <div id="tabContentTvod3" class="tab-content" aria-labelledby="tabNavTvod3">
                        <div id="tvodTermsSec3" class="terms-sec-wrap">
                            <TvodAdvertisingOptIn />
                        </div>
                    </div>
                    <!-- //Tab3_Targeted Advertising Opt-In -->
                </div>
            </div>
        </div>
    </section>
    <!-- //Content -->
</template>

<script>
    import TvodTermsOfUse from '@/components/terms/tvod/TvodTermsOfUse.vue';
    import TvodPrivacyPolicy from '@/components/terms/tvod/TvodPrivacyPolicy.vue';
    import TvodAdvertisingOptIn from '@/components/terms/tvod/TvodAdvertisingOptIn.vue';

    export default {
        name: "Tvod",
        components: {
            TvodTermsOfUse,
            TvodPrivacyPolicy,
            TvodAdvertisingOptIn
        },
        mounted() {
            $(window).scrollTop(0);
            this.$nextTick(function() {
                ui.tab.init();
                ui.termsAcod.init();
                loadLabelledby();
            });
        }
    }
</script>

<style scoped>
.terms-tit {
    line-height: 1.35;
}
.tab-type4 >>> ul li a {
    height: auto;
    min-height: 4.6rem;
}
.tab-type4 >>> ul li a .tit {
    word-break: normal;
    overflow-wrap: break-word;
    line-height: 1.4;
}
/* Site reset sets strong/em to inherit/normal — force visible bold/italic for TVOD */
.terms-sec-wrap >>> h2,
.terms-sec-wrap >>> .tit-h2 {
    font-family: 'NSB', 'LGB', sans-serif;
    font-weight: 600;
}
.terms-sec-wrap >>> h3,
.terms-sec-wrap >>> .tit-h3 {
    font-family: 'NSB', 'LGSB', sans-serif;
    font-weight: 600;
}
.terms-sec-wrap >>> strong,
.terms-sec-wrap >>> b {
    font-family: 'NSB', 'LGB', sans-serif;
    font-weight: 600;
}
.terms-sec-wrap >>> em,
.terms-sec-wrap >>> i {
    font-style: italic;
}
.terms-sec-wrap >>> u {
    text-decoration: underline;
}
</style>
